<header class="print-header">
  <div class="print-header-logo">
    <img src="assets/images/app-logo-for-school-gray.svg" alt="入試正解デジタル for School" />
  </div>
</header>
